export default function ({ redirect, app }) {
  if (app.$utils.isPurchaseEnabledOrAuthenticated) {
    return Promise.resolve()
  }
  return redirect(app.localePath('login'))
}
